import styled from 'styled-components';

export const Anchor = styled.a`
  cursor: pointer;
`;
